<template lang="pug">
	section#categoriaCursos
		.wrapper
			ul
				li(v-for="categoria in categorias", :class="[categoria.tipo]").categoria
					router-link(v-if="!categoria.external" :to="categoria.disable ? '' : { name: 'cursos', params: { tipo: categoria.tipo }, query: { tag: categoria.tagBE || undefined } }" :class="{link_disable: categoria.disable}")
						picture.bg
							img(:src="categoria.bg", :alt="categoria.nome")
						figure.tag
							//- img(src="@images/home/cursos/tag_novo.png", alt="Novo", v-if="categoria.tag.novo").novo
							img(src="@images/home/cursos/tag_desconto.png", :alt="categoria.tag.texto" v-if="categoria.tag").desconto
							figcaption(v-if="categoria.tag") {{ categoria.tag.texto }}
						h2 {{ categoria.nome }}
						p {{ !categoria.disable ? 'ver todos os cursos >' : '&nbsp;' }}
					a(v-if="categoria.external" :href="categoria.link")
						picture.bg
							img(:src="categoria.bg", :alt="categoria.nome")
						figure.tag
							//- img(src="@images/home/cursos/tag_novo.png", alt="Novo", v-if="categoria.tag.novo").novo
							img(src="@images/home/cursos/tag_desconto.png", :alt="categoria.tag.texto" v-if="categoria.tag").desconto
							figcaption(v-if="categoria.tag") {{ categoria.tag.texto }}
						h2 {{ categoria.nome }}
						p {{ !categoria.disable ? 'ver todos os cursos >' : '&nbsp;' }}
</template>

<script>
export default {
	name: "section-cursos",
	data() {
		return {
			categorias: [
				{
					nome: 'Graduação EAD',
					tipo: 'graduacao',
					tagBE:'',
					bg: require('@images/home/cursos/bg_graduacao.jpg'),
					// tag: {
					// 	novo: false,
					// 	texto: 'A partir de R$ 3,33 por dia¹'
					// },
					disable: false,
					external: false,
				},
				{
					nome: 'Graduação Presencial',
					tipo: 'graduacao-presencial',
					tagBE:'',
					bg: require('@images/home/cursos/bg_graduacao-presencial.jpg'),
					// tag: {
					// 	novo: false,
					// 	texto: 'A partir de R$ 3,33 por dia¹'
					// },
					disable: false,
					external: false,
				},
				{
					nome: 'Cursos na área da saúde',
					tipo: 'saude',
					tagBE:'',
					bg: require('@images/home/cursos/bg_saude.jpg'),
					// tag: {
					// 	novo: true,
					// 	texto: 'A partir de R$ 5,23 por dia¹'
					// },
					disable: false,
					external: false,
				},
				{
					nome: 'Cursos na área da engenharia',
					tipo: 'graduacao',
					tagBE:'engenharia',
					bg: require('@images/home/cursos/bg_engenharia.jpg'),
					// tag: {
					// 	novo: true,
					// 	texto: 'A partir de R$ 8,32 por dia¹'
					// },
					disable: false,
					external: false,
				},
				{
					nome: 'Pós-graduação',
					tipo: 'pos-graduacao',
					tagBE:'',
					bg: require('@images/home/cursos/bg_pos.jpg'),
					// tag: {
					// 	novo: false,
					// 	texto: 'A partir de R$ 2,01 por dia¹'
					// },
					disable: false,
					external: false,
				},
				// {
				// 	nome: 'Pós-graduação Internacional',
				// 	tipo: 'pos-graduacao',
				// 	tagBE:'internacional',
				// 	bg: require('@images/home/cursos/bg_pos-internacional.jpg'),
				// 	tag: {
				// 		novo: true,
				// 		texto: 'A partir de R$ 8,13 por dia¹'
				// 	},
				// 	disable: false,
				// },
				{
					nome: 'Cursos Internacionais',
					tipo: 'tecnico',
					tagBE:'',
					bg: require('@images/home/cursos/bg_tecnico.jpg'),
					tag: {
						novo: true,
						texto: 'Novo'
					},
					disable: false,
					external: true,
					link: 'https://www.goexplosion.com/sereduc'
				},
			]
		}
	},
}
</script>

<style lang="stylus" scoped src="./CategoriaCursos.styl"></style>
